import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const getGroupListApi = async () => {
  let res = await axios({
    url: `/api/v2/groups`,
    method: "GET",
    params: {}
  });
  return res.data;
};

export const getGroupTreeListApi = async () => {
  let res = await axios({
    url: `/api/v2/groups/tree`,
    method: "GET",
    params: {}
  });
  return res.data;
};

export const getDeviceListApi = async (group_id, search) => {
  let res = await axios({
    url: `/api/v2/devices`,
    method: "GET",
    params: {
      group_id,
      search
    }
  });
  return res.data;
};

export const createGroupApi = async (name, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/groups/create`,
    method: "POST",
    data: {
      name
    }
  });
  successHandling(t, successfulText);
  return res;
};

export const importDevicesAPI = async (
  group_id,
  spreadsheet,
  t,
  successfulText
) => {
  let formData = new FormData();
  formData.append("group_id", group_id);
  formData.append("spreadsheet", spreadsheet);

  let res = await axios({
    url: `/api/v2/groups/upload/devices`,
    method: "POST",
    data: formData
  });
  successHandling(t, successfulText);
  return res;
};

export const updateGroupApi = async (id, name, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/groups/update`,
    method: "PUT",
    data: {
      id,
      name
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const deleteGroupApi = async (id, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/groups/delete`,
    method: "DELETE",
    data: {
      id
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
export const deleteDeviceFromGroupApi = async (
  device_ids,
  group_id,
  t,
  successfulText
) => {
  const res = await axios({
    url: `/api/v2/device/remove-from-group`,
    method: "DELETE",
    data: {
      device_ids,
      group_id: Array.isArray(group_id) ? undefined : group_id,
      group_ids: Array.isArray(group_id) ? group_id : undefined
    }
  });
  if (successfulText) {
    successHandling(t, successfulText);
  }
  return res.data;
};

export const getUnbindDeviceListApi = async (nubis_group_id, search) => {
  let res = await axios({
    url: `/api/v2/devices`,
    method: "GET",
    params: {
      nubis_group_id,
      search
    }
  });
  return res.data;
};

export const assignToGroupsApi = async (
  device_ids,
  group_id,
  t,
  successfulText
) => {
  let res = await axios({
    url: `/api/v2/device/assign-to-group`,
    method: "PUT",
    data: {
      device_ids,
      group_id
    }
  });
  if (successfulText) {
    successHandling(t, successfulText);
  }
  return res.data;
};

export const transferGroupsApi = async (
  device_ids,
  new_group_id,
  old_group_ids,
  remove_app
) => {
  let res = await axios({
    url: `/api/v2/device/transfer-group`,
    method: "POST",
    data: {
      device_ids,
      new_group_id,
      old_group_ids,
      remove_app
    }
  });
  return res.data;
};
